import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import { isDeviceForbiddenError } from '../../../lib/deviceAuthError'

interface UnpairDeviceResult {
  success?: boolean
  error?: string
}

async function unpairDevice(): Promise<void> {
  const { data, error } = await supabase.functions.invoke<UnpairDeviceResult>('unpair-device')

  if (error || data?.error || data?.success !== true) {
    const failure = error ?? new Error(data?.error ?? 'unpair_device_failed')
    if (!isDeviceForbiddenError(failure)) reportUnexpectedError(failure)
    throw failure
  }
}

export function useUnpairDevice() {
  return useMutation({ mutationFn: unpairDevice })
}
